import { styled, keyframes } from 'goober';
import { appColors } from '@base/useTheme';
import { PipelineStepStatus } from './parsePipelineLogs';

export const STATUS_COLORS: Record<PipelineStepStatus, string> = {
    PENDING: appColors.neutral.w300,
    RUNNING: appColors.primary.w500,
    OK: appColors.success.w500,
    EXTRACTED: appColors.success.w500,
    LOADED: appColors.success.w500,
    EXPORTED: appColors.success.w500,
    FAILED: appColors.error.w500,
    SKIPPED: appColors.neutral.w500,
};

export const STATUS_BG_COLORS: Record<PipelineStepStatus, string> = {
    PENDING: appColors.neutral.w50,
    RUNNING: appColors.primary.w50,
    OK: appColors.success.w50,
    EXTRACTED: appColors.success.w50,
    LOADED: appColors.success.w50,
    EXPORTED: appColors.success.w50,
    FAILED: appColors.error.w50,
    SKIPPED: appColors.neutral.w50,
};

export const NODE_H = 96;

const runningColor = appColors.primary.w500;
const pulse = keyframes`
    0% { box-shadow: 0 0 0 0 ${runningColor}66; }
    70% { box-shadow: 0 0 0 8px ${runningColor}00; }
    100% { box-shadow: 0 0 0 0 ${runningColor}00; }
`;

// Room around the nodes for the selection outline and the running pulse
export const GRAPH_PADDING = 8;

// The scroller takes the room from the box padding, so the nodes line up with the summary line
export const GraphScroller = styled('div')(() => ({
    overflowX: 'auto',
    overflowY: 'auto',
    margin: `0 -${GRAPH_PADDING}px -${GRAPH_PADDING}px`,
}));

export const GraphContainer = styled('div')(() => ({
    position: 'relative' as const,
    minWidth: 'fit-content',
}));

export const StepNodeContainer = styled('div')<{ $status: PipelineStepStatus; $selected?: boolean }>(
    ({ $status, $selected }) => ({
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
        padding: '12px',
        width: '100%',
        minHeight: `${NODE_H}px`,
        boxSizing: 'border-box',
        borderRadius: '8px',
        border: `1px solid ${STATUS_COLORS[$status]}`,
        borderLeft: `4px solid ${STATUS_COLORS[$status]}`,
        backgroundColor: STATUS_BG_COLORS[$status],
        cursor: 'pointer',
        outline: $selected ? `2px solid ${appColors.primary.w500}` : 'none',
        animation: $status === 'RUNNING' ? `${pulse} 2s infinite` : 'none',
        transition: 'outline 0.15s ease',
        '&:hover': {
            filter: 'brightness(0.97)',
        },
    })
);

export const StepStatusLabel = styled('span')<{ $status: PipelineStepStatus }>(({ $status }) => ({
    fontWeight: 500,
    fontSize: '12px',
    color: STATUS_COLORS[$status],
}));

export const StepError = styled('div')(({ theme }) => ({
    fontSize: '10px',
    color: theme.colors.error.w700,
    marginTop: '2px',
}));
